<modal-popup [flexible]="true" [focusOnOpen]="false"
 [isOpen]="true" (onClose)="close()" [title]="title" 
 [afterTitle]="claimToolComponent?.first ? claimToolComponent.first.headerActions : dirtyBtns"
  [footerTemplate]="claimToolComponent?.first ? null : footer"
  [isLoading]="claimToolComponent?.first ? claimToolComponent.first.isLoading : loading"
  [alignLeft]="indModeSw" [cssClass]="detailsDialogClass">
  <info-details drawer [details]="drawerDetails"
  [label]="detailsDialogLabel"
    [isExpanded]="isExpanded"
    ></info-details>
<ng-container *ngIf="!showClaimToolDialog; else claimToolTemplate">
  <div [ngClass]="{ 'cat-doc-phrase-details-modal-container': isExpanded }">
    <!-- Change condition to not consider catMatches && getSimilarityEvent -->
    <div [ngClass]="{ 'cat-doc-phrase-details-container': isExpanded }">
      <div class="l-align-spaceBetween">
        <h3>
          {{
          phrase
          ? ("translate.general.workingPhrase" | translate)
          : ("translate.general.workingImage" | translate)
          }}

          <!--figure type-->
          <!-- <p *ngIf="image" [ngClass]="['status-tag']">
          {{ element.figureTypeDescr }}
        </p> -->
        </h3>

        <!-- status-->
        <div *ngIf="indModeSw && !extSw">
          <p *ngIf="element.statusCode" [ngClass]="['cat-phrase-status', element.statusCode]">
            {{ element.statusDescr }}
          </p>
          <spinner *ngIf="!element.statusCode && element.hasId" class="cat-phrase-status-spinner"></spinner>
        </div>
      </div>

      <div *ngIf="isExpanded && catMatches.length > 0 && getSimilarityEvent() && notPotentialNew" class="cat-doc-phrase-details-navigation">
        <div class="cat-doc-phrase-details-nav-button-continer">
          <button (click)="prevMatch()" [disabled]="currentIndex === 0"
            class="cat-doc-phrase-details-nav-button cat-doc-phrase-details-nav-button-left">
            <i class="fas fa-arrow-left"></i>
            {{ "translate.cat.prev" | translate }}
          </button>
        </div>

        <div class="cat-doc-phrase-details-current">Current match</div>

        <div class="cat-doc-phrase-details-nav-button-continer">
          <button (click)="nextMatch()" [disabled]="currentIndex === catMatches.length - 1"
            class="cat-doc-phrase-details-nav-button cat-doc-phrase-details-nav-button-right">
            {{ "translate.cat.next" | translate }}
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>
      <!-- ToDo: Add condition to display empty div when there is no matches and isExpanded -->
       <div *ngIf="isExpanded && (catMatches.length == 0 || !getSimilarityEvent() || !notPotentialNew)"></div>
          
      
      <!-- phrase text -->
      <div *ngIf="phrase">
        <div *ngIf="phrase.hasId" class="phrase-txt" (mouseenter)="displayPhraseEditBtn = !editModeSw"
          (mouseleave)="displayPhraseEditBtn = false">
          <span *ngIf="phrase.phraseWords.length == 0">
            {{ phrase.phraseText }}
          </span>
          <formatted-phrase *ngIf="phrase.phraseWords.length > 0" [phraseWords]="phrase.phraseWords"
            [grammarSpellingIssues]="phrase.grammarSpellingIssues"
            (onAddToWhitelist)="onAddToWhitelist($event)"
            [referenceIssues]="phrase.referenceIssues"></formatted-phrase>
            <!--
            <div style="display: flex; flex-direction: column; margin-top: 10px" *ngIf="element.consistencyIssues && element.consistencyIssues.length > 0">
              
              <p class="cat-doc-phrase-details-ref-title">{{ "translate.rev.consistencyIssues" | translate }}:</p>
              <div class="cat-doc-phrase-details-ref-container" style="background-color: #fce9e8 !important">
              <div style="display:flex;" [ngStyle]="i > 0 ? { 'margin-top': '10px' } : {} " *ngFor="let consistencyIssue of element.consistencyIssues; let i = index"
              >
                <i class="priority-high" style="padding-top: 5px"
                  ></i>
                    <div style="flex: 1; padding-top: 5px; padding-bottom: 5px; padding-left: 5px; padding-right: 5px;" >
                      <p>
                  {{ consistencyIssue.reason }}
                      </p>
                    </div>
                      <a (click)="showConsistencyIssuesPhrases(consistencyIssue)" style="padding-top: 5px; width: 40px;">
                        {{ "translate.general.view" | translate }}
                      </a> 
              </div>
              </div>
            </div>
          -->


          <!--
          <i *ngIf="editable && !editModeSw && inCatEditable" (click)="editModeSw = true"
            class="fas fa-edit icon-edit"></i>
          <i *ngIf="editable && editModeSw" (click)="undoPhraseEdit()" class="fas fa-times icon-edit"></i>
          -->
          <i *ngIf="editable && !editModeSw && inCatEditable" class="fas fa-file-invoice icon-edit" (click)="showClaimTool()"
              [tooltip]="(phrase?.phraseContentType === 'TEXT_CONTENT' ? 'translate.text.tool' : 'translate.claim.tool') | translate"></i>
         
          <!-- consistency issues-->
           <ng-container *ngTemplateOutlet="consistencyIssues"></ng-container>
          <ng-container *ngIf="element.fairBalanceIssues && element.fairBalanceIssues.length > 0">

              <div style="display: flex; margin-top: 10px;">
                <span style="margin-right: 5px" class="circle-badge error">{{ element.fairBalanceIssues.length }}</span>
                <a class="cat-doc-phrase-details-ref-title" (click)="hideFairBalanceIssuesTable = !hideFairBalanceIssuesTable">
                  {{ "translate.general.fairBalanceIssues" | translate }}
                  <span [ngClass]="hideFairBalanceIssuesTable ? 'pi pi-angle-down' : 'pi pi-angle-up'"></span>
                </a>
              </div>
          <slide-in-out [isOpen]="!hideFairBalanceIssuesTable">

            <div class="cat-phrase-ref-container" style="margin-top: 0.3em; height: auto !important; background-color: #fce9e8 !important; padding: 0.1em !important">
              <fair-balance-issues [fairBalanceIssues]="element.fairBalanceIssues"
              [phrase]="phrase"
              [disableActions]="conditionForDisablingConsistencyCheckResultActions"
              (viewFairBalanceIssueEvent)="viewFairBalanceIssue($event)">
              </fair-balance-issues>
              <p style="font-style:  italic; text-align: right; margin-right: 0.4em; margin-top: 0.2em; margin-bottom: 0.2em; color: #9d9fa2">
                <ai-icon></ai-icon>
              </p>
            </div>
          </slide-in-out>

          </ng-container>
      <ng-container *ngIf="element.complianceIssues && element.complianceIssues.length > 0">

              <div style="display:flex; margin-top: 10px; margin-right: 5px;">
                <span style="margin-right: 5px" class="circle-badge error">{{ element.complianceIssues.length }} </span>
                <a class="cat-doc-phrase-details-ref-title" (click)="hideComplianceIssuesTable = !hideComplianceIssuesTable">
                  {{ "translate.general.complianceIssues" | translate}}
                  <span [ngClass]="hideComplianceIssuesTable ? 'pi pi-angle-down' : 'pi pi-angle-up'"></span>
                </a>
              </div>
              <div></div>
          <slide-in-out *ngIf="!hideComplianceIssuesTable" [isOpen]="!hideComplianceIssuesTable">
            <div class="cat-phrase-ref-container" style="margin-top: 0.3em; height: auto !important; background-color: #fce9e8 !important; padding: 0.1em !important">
              <compliance-issues [complianceIssues]="element.complianceIssues"
              [phrase]="element"
              [disableActions]="conditionForDisablingConsistencyCheckResultActions"
              >
              </compliance-issues>
              <p style="font-style:  italic; text-align: right; margin-right: 0.4em; margin-top: 0.2em; margin-bottom: 0.2em; color: #9d9fa2">
                <ai-icon></ai-icon>
              </p>
            </div>
          </slide-in-out>
          <div *ngIf="!hideComplianceIssuesTable"></div>
      </ng-container>
        </div>

        <!-- phrase edit mode -->
        <div *ngIf="editModeSw">
          <textarea *ngIf="catModeSw" class="edit-phrase-area" pTextarea [(ngModel)]="editPhraseText"
            autoResize="true"></textarea>

          <div *ngIf="indModeSw" class="fake-textarea edit-phrase-area">
            <formatted-phrase [phraseWords]="editPhraseTextWords"></formatted-phrase>
          </div>

          <div *ngIf="phrase.mergeOptions.length > 0">
            <span *ngIf="phrase.hasId" class="t-footnote">
              {{ "translate.cat.mergeWithNearest" | translate }}
            </span>

            <div class="merge-listbox t-small">
              <p-listbox [options]="phrase.mergeOptions" [(ngModel)]="selectedLines" [checkbox]="true" [multiple]="true"
                dataKey="uniqueId" optionLabel="text" (onClick)="onMergeOptionsClicked($event)"
                [listStyle]="{ 'max-height': '250px' }">
                <ng-template let-item pTemplate="item">
                  <div class="l-flex-column w-full">
                    <div class="l-align-spaceBetween w-full">
                      <p *ngIf="item.phraseWords.length == 0">
                        {{ item.text }}
                      </p>
                      <formatted-phrase *ngIf="item.phraseWords.length > 0"
                        [phraseWords]="item.phraseWords"></formatted-phrase>

                      <p (click)="$event.stopPropagation()" class="t-footnote phrase-id l-align-center">
                        <button class="t-button t-button--pill t-btn-more bg-white"
                          (click)="item.displayWordsSw = !item.displayWordsSw">
                          <i class="fas fa-angle-down"></i>
                        </button>
                        &nbsp; &nbsp;
                        <span> Phrase {{ item.phraseId }}</span>
                      </p>
                    </div>
                    <div (click)="$event.stopPropagation()">
                      <slide-in-out [isOpen]="item.displayWordsSw">
                        <div class="l-flex l-wrap">
                          <div *ngFor="let word of item.phraseWords">
                            <checkbox-wrap class="checkbox" [label]="word.text">
                              <input type="checkbox" [(ngModel)]="word.checked"
                                (ngModelChange)="onMergeWordChange(item)" />
                            </checkbox-wrap>
                            &nbsp;&nbsp;
                          </div>
                        </div>
                      </slide-in-out>
                    </div>
                  </div>
                </ng-template>
              </p-listbox>
            </div>
          </div>
        </div>
      </div>
      <!-- ToDo: Add condtion to display template for no matches if is expanded and no matches-->
    
      <div *ngIf="isExpanded && phrase && catMatches.length > 0 && getSimilarityEvent() && notPotentialNew">
        <cat-match-phrase [disableConsistencyCheckResultsActions]="conditionForDisablingConsistencyCheckResultActions" (revertConsistencyCheckResultEmitter)="revertConsistencyCheckResult(catMatches[currentIndex])" [catMatch]="catMatches[currentIndex]"></cat-match-phrase>
      </div>
      <div *ngIf="!loading && isExpanded && phrase && (catMatches.length == 0 || !notPotentialNew || !getSimilarityEvent()) ">
        <ng-container *ngTemplateOutlet="noMatches"></ng-container>
      </div>
    <!-- images -->
    <div *ngIf="image" class="t-row--med">
      <!-- <img class="ind-img" [src]="image.imgUrl" /> -->
      <async-img [className]="imageClassName" *ngIf="image.imgS3Key"  [url]="image.imgUrl"></async-img>
    </div>
    <ng-container *ngIf="isExpanded && catMatches.length > 0 && image && getSimilarityEvent()">
      <ng-container *ngTemplateOutlet="imageMatchesTemplate"></ng-container>
    </ng-container>

      <!-- ToDo: Add condtion to display template for no matches if is expanded and no matches-->
      <div *ngIf="!loading && isExpanded && indModeSw && image && (catMatches.length == 0 || !notPotentialNew || !getSimilarityEvent()) ">
        <ng-container *ngTemplateOutlet="noMatches"></ng-container>
      </div>
    <ng-container *ngIf="image">
      <ng-container *ngTemplateOutlet="consistencyIssues"></ng-container>
    </ng-container>
    <div *ngIf="isExpanded && image"></div>
    </div>

    <!--
    <div *ngIf="image" [ngClass]="isExpanded ? 'halfWidth' : ''">
      <ng-container *ngTemplateOutlet="consistencyIssues"></ng-container>

    </div>
    -->
    <!-- figure type - closed-->
    <div *ngIf="element.figureType" class="cat-phrase-type">
      <span>
        {{ element.figureTypeDescr }}
        <span *ngIf="element.figureSubType" class="sub-type">&middot; {{ element.figureSubType.text }}</span>
      </span>
      <i *ngIf="editable && element.figureType != 'IMAGE' && element.hasId" (click)="opFigureSubTypes.toggle($event)" class="fas fa-edit icon-edit"></i>
      <i *ngIf="editable && element.figureType == 'IMAGE' && element.hasId && imageCategoriesForDoc?.length > 0"
      (click)="opImageCategories.toggle($event)" class="fas fa-edit
      icon-edit"></i>
    </div>

    <div class="action-btn-container">
      <!-- select type - closed -->
      <div class="cat-phrase-type" (mouseenter)="displayTypeEditBtn = true" (mouseleave)="displayTypeEditBtn = false">
        <span *ngIf="phrase">{{ phrase.phraseContentTypeDesc }}&middot; </span>
        <span *ngIf="element.typeCode && element.subTypeCode">
          {{ element.typeDescr }}
          <span class="sub-type">&middot; {{ element.subTypeDescr }}</span>
        </span>

        <span *ngIf="editable && element.hasId && !(element.typeCode && element.subTypeCode)">
          Select type
        </span>

        <i *ngIf="editable && element.hasId" (click)="opTypes.toggle($event)" class="fas fa-edit icon-edit"></i>
      </div>

      <!--select type - open -->
      <div *ngIf="!element.hasId && (!element.typeCode || !element.subTypeCode)" class="w-full t-row--med">
        <p class="fs-small t-row--small fw-semibold">
          {{ "translate.cat.phraseType" | translate }}
        </p>
        <ng-container *ngTemplateOutlet="typesTree"></ng-container>
      </div>

      <!--status button-->
      <p-selectButton [disabled]="conditionForDisablingStatusChanges" *ngIf="indModeSw && element.hasId && editable" class="cat-phrase-status"
        [options]="phraseStatusOptions" [(ngModel)]="element.userStatus" (onChange)="onElementStatusChange()"
        style="margin-top: 10px; margin-bottom: 10px"></p-selectButton>
    </div>

    <!--cat entry status-->

    <div>
      <div *ngIf="element.catEntryStatus" class="cat-entry-status cat-phrase-type">
        <span>
          {{ element.catEntryStatus.text }}
        </span>
        <i *ngIf="editable" (click)="opCatEntryStatus.toggle($event)" class="fas fa-edit icon-edit"></i>
      </div>
    </div>

    <div [ngClass]="{
      'cat-doc-phrase-details-scrollable-grid': true,
      'cat-doc-phrase-details-container': isExpanded && catMatches.length > 0 && getSimilarityEvent()
      }">

      <!-- <ng-container *ngTemplateOutlet="suggestedReferencesTemplate; context: { references: suggestedReferences, hideSuggestedReferences: { toggleVisibility: hideSuggestedReferences }, label: 'translate.general.suggested.references' }"> 
      
      </ng-container> -->

      <ng-container *ngTemplateOutlet="referencesTemplate; context: { references: references, hideReferences: { toggleVisibility: hideReferences }, referenceIssues: phrase?.referenceIssues, label: 'translate.rev.reference', labelRightHandSide: 'translate.rev.reference.righthandSide', hasReferencesIssues: hasReferencesIssue(references, false), isFootnote: false }">
        
      </ng-container>

      <ng-container *ngIf="!isAddAnchorsDisabled() && phrase && !(references.length > 0 || (anchorContext && anchorContext.length > 0) || (isExpanded && catMatches.length > 0 && getSimilarityEvent() && hasReferencesIssue(references, false))) && editable && inCatEditable">
        <div style="margin-top: 10px; margin-bottom: 10px">
            <a [class.disabled]="conditionForDisablingConsistencyCheckResultActions" (click)="toggleAddContextDropdown()" class="add-context-btn" style="cursor: pointer;">
                
              <i [class.disabled]="conditionForDisablingConsistencyCheckResultActions" [ngClass]="showAddContextDropdown.value ? 'fas fa-minus' : 'fas fa-plus'"></i>  {{ "translate.cat.addReference" | translate }}
            </a>
          </div>
          <div></div>
      <ng-container *ngIf="showAddContextDropdown.value">
        <add-anchor [disabled]="conditionForDisablingConsistencyCheckResultActions" [curDoc]="curCatDoc" [phrase]="phrase"
        [showAddContextDropdown]="showAddContextDropdown">

        </add-anchor>
        <div></div>
      </ng-container>
      </ng-container>

      <ng-container *ngTemplateOutlet="referencesTemplate; context: { references: footnotes, hideReferences: { toggleVisibility: hideFootnotes }, referenceIssues: phrase?.referenceIssues, label: 'translate.rev.footnotes', labelRightHandSide: 'translate.rev.footnotes.righthandSide', hasReferencesIssues: hasReferencesIssue(footnotes, true), isFootnote: true }">
        
      </ng-container>

      <ng-container #associatedImages *ngTemplateOutlet="imagesTemplate; context: { images: images, hideAssociatedImages: hideAssociatedImages, label: 'translate.general.associatatedImages', labelRightHandSide: 'translate.general.associatatedImages.righthandSide', hasAssociatedImageIssues: hasAssociatedImagesIssue(images, false), isTables: false }">
        
      </ng-container>
    
      <ng-container #associatedTables *ngTemplateOutlet="imagesTemplate; context: { images: tables, hideAssociatedImages: hideAssociatedTables, label: 'translate.general.associatedTables', labelRightHandSide: 'translate.general.associatedTables.righthandSide', hasAssociatedImageIssues: hasAssociatedImagesIssue(tables, true), isTables: true }">
        
      </ng-container>

      <ng-container *ngIf="phrase && (phrase.associatedText.length > 0 || hasAssociatedTextIssue())">
        <div style="display: flex; margin-top: 5px">
            <ng-container *ngIf="phrase.isFullyFetched else loadingSpinner">
              <span style="margin-right: 5px" class="circle-badge" [ngClass]="!hasAssociatedTextIssue() ? 'success' : (isFullMatch ? 'warning-info' : 'error')">
                <i [ngClass]="!hasAssociatedTextIssue() ? 'pi pi-check' : (isFullMatch ? 'pi pi-exclamation-triangle' : 'pi pi-times')"></i>
              </span>
            </ng-container>
            <a class="cat-doc-phrase-details-ref-title" (click)="hideAssociatedText = !hideAssociatedText">
              {{ "translate.general.associatedText" | translate }}
              <span [ngClass]="hideAssociatedText ? 'pi pi-angle-down' : 'pi pi-angle-up'" style="margin-left: 0.3em;"></span>
            </a>
        </div>
        <ng-container *ngIf="isExpanded && catMatches.length > 0 && getSimilarityEvent()">
          <div></div>
        </ng-container>
        <ng-container *ngFor="let assocPhrase of phrase.associatedText">
          <slide-in-out *ngIf="!hideAssociatedText" [isOpen]="!hideAssociatedText" [cssClass]="'accordionHeight'">
          <div class="cat-doc-phrase-ref-container">
            <!-- <cat-phrase-ref class="ref" [ref]="ref" [mainPhrase]="phrase" (onDeleteRef)="onDeleteRef(ref)"
              [editable]="editable && inCatEditable" [allowEdit]="catModeSw"></cat-phrase-ref> -->
              <div class="cat-phrase-ref-container">
                {{ assocPhrase.assocPhraseText }}
                <div class="l-align-spaceBetween l-mar-top">
                  <span class="footnote id"
                    >{{ "translate.cat.phraseId" | translate }}: {{ assocPhrase.assocPhraseId }}</span
                  >
                </div>
              </div>
              
          </div>
          </slide-in-out>

          <ng-container *ngIf="isExpanded && catMatches.length > 0 && getSimilarityEvent()">
            <slide-in-out [isOpen]="!hideAssociatedText" [isOpen]="!hideAssociatedText" [cssClass]="'accordionHeight'">
              <div class="issues-column" style="height: 100%;">
                <ng-container *ngIf="getAssociatedTextFinding(catMatches[currentIndex].catPhrase.phraseId, assocPhrase.assocPhraseId)?.assocTextFinding === 'ADDED_ASSOC_TEXT'">
                  <div class="ref ref-match-container missing-reference" style="direction: rtl; padding-right: 0.5rem;">
                    <div class="ref-similarity-code">
                      <p class="extra">
                        {{ "translate.rev.refAdded" | translate }}
                      </p>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!(getAssociatedTextFinding(catMatches[currentIndex].catPhrase.phraseId, assocPhrase.assocPhraseId)?.assocTextFinding === 'ADDED_ASSOC_TEXT')">
                  <cat-match-phrase-assoc-text class="ref" [associatedText]="assocPhrase" [mainPhrase]="catMatches[currentIndex].catPhrase"
                    [associatedTextFinding]="getAssociatedTextFinding(catMatches[currentIndex].catPhrase.phraseId, assocPhrase.assocPhraseId)">
                  </cat-match-phrase-assoc-text>
                </ng-container>
              </div>
            </slide-in-out>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="isExpanded && catMatches.length > 0 && getSimilarityEvent()">
          <ng-container *ngFor="let issue of getMissingAssocTextFinding(catMatches[currentIndex].catPhrase.phraseId)">
            <slide-in-out *ngIf="!hideAssociatedText" [isOpen]="!hideAssociatedText" [cssClass]="'accordionHeight missing-reference'">
              <div class="reference-column">
                <div class="ref missing-reference"></div>
              </div>
            </slide-in-out>
            <slide-in-out *ngIf="!hideAssociatedText" [isOpen]="!hideAssociatedText" [cssClass]="'accordionHeight'">
              <div class="issues-column" style="height: 100%">
                <div class="cat-doc-phrase-details-ref-container">
                  <div class="ref-match-container">
                    <div>
                      <p class="text">
                        {{ getCatPhraseAssocText(issue.catAssocPhraseId)?.assocPhraseText }}
                      </p>
                      <p class="ref-id">
                        {{ "translate.cat.phraseId" | translate }}: {{ issue.catAssocPhraseId }}
                      </p>
                    </div>
                    <div class="anchor-context-issue-label">
                      <p class="missing">
                        {{ "translate.rev.refMissing" | translate }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </slide-in-out>
          </ng-container>
        </ng-container>
      </ng-container>

    </div>
    <!-- Add context
    <cat-doc-ref-options *ngIf="displayRefOptions" (onRefAdd)="onPhraseRefAdd($event)"
      (onRefRemove)="onPhraseRefRemove($event)"></cat-doc-ref-options>
    -->
    <!--referenced by -->
    <div *ngIf="phrase && phrase.referencedBy.length > 0 && phrase.isRefSw" class="reference t-row--med">
      <p class="title">{{ "translate.rev.referencedBy" | translate }}:</p>
      <div *ngFor="let ref of phrase.referencedBy" class="ref-container text l-flex-column">
        <p *ngIf="ref.phraseDispWords.length == 0">
          {{ ref.refPhraseText }}
        </p>
        <formatted-phrase *ngIf="ref.phraseDispWords.length > 0" [phraseWords]="ref.phraseDispWords"
          class="t-row--small"></formatted-phrase>
        <div>
          <span class="footnote id">{{ "translate.cat.phraseId" | translate }}:
            {{ ref.phraseId }}</span>
        </div>
      </div>
    </div>

    <!--associated by -->
    <div *ngIf="element.associatedBy?.length > 0" style="margin-top: 5px" class="reference t-row--med">
      <p class="title">{{ "translate.general.associatedBy" | translate }}:</p>
      <div *ngFor="let assocPhrase of element.associatedBy" class="ref-container text l-flex-column">
        <p *ngIf="assocPhrase.phraseDispWords.length == 0">
          {{ assocPhrase.assocPhraseText }}
        </p>
        <formatted-phrase *ngIf="assocPhrase.phraseDispWords.length > 0" [phraseWords]="assocPhrase.phraseDispWords"
          class="t-row--small"></formatted-phrase>
        <div>
          <span class="footnote id">{{ "translate.cat.phraseId" | translate }}:
            {{ assocPhrase.phraseId }}</span>
        </div>
      </div>
    </div>
    <!-- Add context buttons
    <div class="l-align-spaceBetween" style="margin-top: 0.5rem;">
      <a *ngIf="editable && inCatEditable" (click)="addReference()" class="add-link">
        <i class="fas fa-plus"></i>
        &nbsp;
        {{ "translate.cat.addReference" | translate }}
      </a>
      <a *ngIf="displayRefOptions" (click)="displayRefOptions = false" class="t-small">
        {{ "translate.general.close" | translate }}
      </a>
    </div>
    -->
    <!-- Add content buttons
    <div class="l-align-spaceBetween" style="margin-top: 0.5rem;">
      <a (click)="addAssociatedText()" class="add-link">
        <i class="fas fa-plus"></i>
        &nbsp;
        {{ "translate.cat.addAssociatedText" | translate }}
      </a>
      <a *ngIf="displayAssocTextOptions" (click)="displayAssocTextOptions = false" class="t-small">
        {{ "translate.general.close" | translate }}
      </a>
    </div>
    -->
    <!-- Add content
    <cat-doc-assoc-text-options *ngIf="displayAssocTextOptions" (onAssocTextAdd)="onAssociatedTextAdd($event)"
      (onAssocTextRemove)="onAssociatedTextRemove($event)"></cat-doc-assoc-text-options>
    --> 
    <!--ext ref-->
    <div *ngIf="phrase && phrase.extRefs.length > 0" class="ext-ref t-row--med">
      <p class="title">{{ "translate.cat.extRefs" | translate }}:</p>
      <div *ngFor="let ref of phrase.extRefs">
        <div class="ref-container text l-flex-column">
          <formatted-phrase [phraseWords]="ref.extPhraseDispWords"></formatted-phrase>

          <div class="actions">
            <a (click)="removeExtRef(ref)" class="t-small">Remove</a>
          </div>
        </div>

        <p class="footnote l-ta-end">
          {{ ref.extDocName }} ({{ ref.extCatDescr }}) &nbsp;
        </p>
      </div>
    </div>

    <!-- instructions-->
    <div>
      <h3 *ngIf="element.addInstr && element.addInstr.length > 0">
        {{ "translate.rev.instructions" | translate }}
      </h3>

      <cat-add-instr *ngFor="let instr of element.addInstr" [instr]="instr" (onDelete)="onDeleteInstr(instr)"
        [editable]="editable"></cat-add-instr>

      <a *ngIf="editable" (click)="addInstr()" class="add-link">
        <i class="fas fa-plus"></i>
        &nbsp;
        {{ "translate.cat.addMoreInstr" | translate }}
      </a>
    </div>

    <!--docs-->
    <div *ngIf="displayEntryDocs && element.docs && element.docs.length > 0" class="docs-container t-small">
      <a (click)="displayDocsSw = !displayDocsSw">
        {{ "translate.cat.matchSourceDocs" | translate }}
      </a>
      <slide-in-out [isOpen]="displayDocsSw">
        <div class="docs-tbl">
          <cat-entry-docs [docs]="element.docs"></cat-entry-docs>
        </div>
      </slide-in-out>
    </div>




    <!-- matches - backward compatibility -->
    <ng-container *ngIf="!getSimilarityEvent()">
      <ng-container *ngTemplateOutlet="matchesTemplate"></ng-container>
    </ng-container>

    <div class="l-align-spaceBetween l-mar-top">
      <p [style.visibility]="element.hasId ? 'visible' : 'collapsed'" class="footnote id">
        <span *ngIf="phrase"> {{ "translate.cat.phraseId" | translate }}</span>
        <span *ngIf="image"> {{ "translate.cat.imageId" | translate }}</span>
        <span>: {{ element.elementId }}</span>
      </p>

      <!-- save and delete buttons -->
      <div>
        <button *ngIf="element.hasId && editable" class="t-button-outline t-button-warn" [disabled]="loading"
          (click)="onDeleteClicked()">
          <span *ngIf="phrase">
            {{ "translate.cat.deletePhrase" | translate }}</span>
          <span *ngIf="image">
            {{ "translate.cat.deleteImage" | translate }}</span>
        </button>

        <button *ngIf="!element.hasId" class="t-button" [disabled]="loading || !validateBeforeSave()"
          (click)="onSaveClickedPreProcessing()">
          {{ "translate.general.save" | translate }}
        </button>
      </div>
    </div>
    <!--<loader *ngIf="loading"></loader>-->
  </div>
</ng-container>
</modal-popup>

<ng-template #claimToolTemplate>

  <claim-tool 
  #claimTool
  [presentation]="'embedded'" (showDetailsDialogEmitter)="returnToDetailsFromClaimTool()"
  (saved)="onClaimToolSaved()"
  (onClose)="returnToDetailsFromClaimTool()" [claim]="claimToolElement"></claim-tool>
</ng-template>

<ng-template #suggestedReferencesTemplate let-references="references" let-label="label"
  let-hideSuggestedReferences="hideSuggestedReferences">
  <ng-container *ngIf="references && references.length > 0">
    <div style="display: flex; margin-top: 5px">
      <span style="margin-right: 5px" class="circle-badge success"><i class="pi pi-check"></i></span>
      <a class="cat-doc-phrase-details-ref-title" (click)="toggleVisibility(hideSuggestedReferences)">{{ label |
        translate }}
        <span [ngClass]="hideSuggestedReferences.toggleVisibility ? 'pi pi-angle-down' : 'pi pi-angle-up'"
          style="margin-left: 0.3em;"></span>
      </a>
    </div>
    <div></div>
    <slide-in-out *ngIf="!hideSuggestedReferences.toggleVisibility" [isOpen]="!hideSuggestedReferences.toggleVisibility">
      <ng-container *ngFor="let ref of references">

        <div class="cat-doc-phrase-ref-container" style="margin-top: 10px !important">
          <phrase-ref class="ref" [ref]="ref" [mainPhraseWords]="phrase.phraseWords" [saveOriginalOnInit]="false" (onDeleteRef)="onDeleteRef(ref)"
            [editable]="false" [allowEdit]="false" [mainPhrase]="phrase"
            [disableConsistencyCheckResultsActions]="conditionForDisablingConsistencyCheckResultActions"
            (viewPageAndRefEmitter)="viewPageAndRef($event)"></phrase-ref>
        </div>
      </ng-container>
    </slide-in-out>

  </ng-container>
</ng-template>
  <ng-template #referencesTemplate let-isFootnote="isFootnote" let-references="references" let-hasReferencesIssues="hasReferencesIssues" let-label="label" let-labelRightHandSide="labelRightHandSide" let-hideReferences="hideReferences" let-referencesIssues="referencesIssues">
      <ng-container *ngIf="(phrase && (references.length > 0 || (!isFootnote && anchorContext.length > 0))) || (isExpanded && catMatches.length > 0 && getSimilarityEvent() && hasReferencesIssues)">
        <div style="display: flex; margin-top: 5px; align-items: center;">
            <ng-container *ngIf="phrase.isFullyFetched else loadingSpinner">
              <span style="margin-right: 5px" class="circle-badge" [ngClass]="!hasReferencesIssues ? 'success' : 'error'"><i [ngClass]="!hasReferencesIssues ? 'pi pi-check' : 'pi pi-times'"></i>
              </span>
            </ng-container>
            <a class="cat-doc-phrase-details-ref-title" style="margin-bottom: 0px" (click)="toggleVisibility(hideReferences)">{{ label | translate }}            
              <span [ngClass]="hideReferences.toggleVisibility ? 'pi pi-angle-down' : 'pi pi-angle-up'" style="margin-left: 0.3em;"></span>
            </a>

        </div>
        <ng-container *ngIf="isExpanded && catMatches.length > 0 && getSimilarityEvent()">
            <div class="cat-doc-phrase-details-ref-title"><span *ngIf="!hideReferences.toggleVisibility">{{ labelRightHandSide | translate }}</span></div>
        </ng-container>
          <ng-container *ngIf="!isAddAnchorsDisabled() && !isFootnote && editable && inCatEditable && !hideReferences.toggleVisibility">
              <div style="margin-top: 5px; margin-bottom: 5px">
                <a [class.disabled]="conditionForDisablingConsistencyCheckResultActions" (click)="toggleAddContextDropdown()" class="add-context-btn" style="margin-left: 0.5rem; cursor: pointer;">
                  <i [class.disabled]="conditionForDisablingConsistencyCheckResultActions" [ngClass]="showAddContextDropdown.value ? 'fas fa-minus' : 'fas fa-plus'"></i>  {{ "translate.cat.addReference" | translate }}
                </a>
              </div>
              <div></div>
          </ng-container>
        <ng-container *ngIf="phrase && references.length > 0">
          <ng-container *ngFor="let ref of references">
            <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility" [cssClass]="'accordionHeight'">
              <div class="cat-doc-phrase-ref-container" [class.border-indicator-reference]="!isFootnote">
                
                @let referenceIssue = getReferenceIssue(catMatches[currentIndex]?.catPhrase?.phraseId, ref.refPhraseId);
                <phrase-ref class="ref" [ref]="ref" [mainPhraseWords]="phrase.phraseWords" [saveOriginalOnInit]="false" (onDeleteRef)="onDeleteRef(ref)"
                  [editable]="editable && inCatEditable" [allowEdit]="catModeSw"
                  [mainPhrase]="phrase"
                  (viewPageAndRefEmitter)="viewPageAndRef($event)"
                  [curCatDoc]="curCatDoc"
                  [disableConsistencyCheckResultsActions]="conditionForDisablingConsistencyCheckResultActions"
                  [refDoc]="getRefDoc(ref)"
                  [showReferenceIssueType]="true"
                  [referenceIssue]="referenceIssue"></phrase-ref>
              </div>
            </slide-in-out>
            <ng-container *ngIf="isExpanded && catMatches.length > 0 && getSimilarityEvent()">
              <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility" [cssClass]="'accordionHeight missing-reference'" >
                <div class="issues-column" style="height: 100%">
                  <ng-container *ngIf="getReferenceIssue(catMatches[currentIndex].catPhrase.phraseId, ref.refPhraseId)?.refFinding === 'ADDED_REFERENCE'">
                    <div class="ref ref-match-container missing-reference" style="direction: rtl; padding-right: 0.5rem;">
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!(getReferenceIssue(catMatches[currentIndex].catPhrase.phraseId, ref.refPhraseId)?.refFinding === 'ADDED_REFERENCE')">
                    <cat-match-phrase-ref class="ref" [ref]="ref" [mainPhrase]="phrase" [catPhrase]="catMatches[currentIndex].catPhrase"
                      [referenceIssue]="getReferenceIssue(catMatches[currentIndex].catPhrase.phraseId, ref.refPhraseId)"
                      [refMatches]="catMatches[currentIndex].refMatch"
                      [showBorderIndicator]="!isFootnote"
                      [disableConsistencyCheckResultsActions]="conditionForDisablingConsistencyCheckResultActions"
                      [workingPhrase]="phrase">
                    </cat-match-phrase-ref>
                  </ng-container>
                </div>
              </slide-in-out>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="isExpanded && catMatches.length > 0 && getSimilarityEvent()">
          <ng-container *ngFor="let issue of getMissingReferenceIssue(catMatches[currentIndex].catPhrase.phraseId, isFootnote)">
            <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility" [cssClass]="'accordionHeight missing-reference'">
              <div class="reference-column">
                <div class="ref missing-reference"></div>
              </div>
            </slide-in-out>
            <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility" [cssClass]="'accordionHeight'">
                @let catPhraseReference = getCatPhraseReference(issue?.catRefPhraseId);              
              <div class="issues-column" [ngClass]="getBorderClass(catPhraseReference)" style="height: 100%; position: relative;">
                <div class="cat-doc-phrase-details-ref-container">                  
                  <div class="ref-match-container" style="display: flex; flex-direction:  column;">
                    <div>
                      <p class="text">
                        {{ catPhraseReference?.refPhraseText }}
                      </p>
                    <mng-anchors *ngIf="phrase" style="margin-top: 10px"  [anchors]="catPhraseReference.anchors"
                          (viewPageAndRef)="viewPageAndRef($event)"
                          [phrase]="phrase"
                          (anchorToRemove)="removeIssueEvent()"
                          (showRefDoc)="viewRefDoc(catPhraseReference)"
                          [displayActions]="false"
                          [disableActions]="conditionForDisablingConsistencyCheckResultActions"
                          [copyAnchors]="true"
                          [moveCopyButton]="false"
                          [isMissingInWorkingPhrase]="true"
                          [catMatchReference]="catPhraseReference"
                          [referenceIssue]="issue"
                          >
                    </mng-anchors>
                      <p class="ref-id">
                        {{ "translate.cat.phraseId" | translate }}: {{ issue.catRefPhraseId }}
                      </p>
                    </div>
                    <div style="display: flex; flex-direction: column;">
                      <div style="margin-right: 5px;" *ngIf="catPhraseReference.anchors != null && catPhraseReference.anchors.length > 0">
                          <copy-all-anchors [isMissingInWorkingPhrase]="true" 
                          [phrase]="phrase"
                          [copyAnchors]="true"
                          [disableConsistencyCheckResultsActions]="conditionForDisablingConsistencyCheckResultActions"
                          [catMatchReference]="catPhraseReference"
                          [catMatchRefAnchors]="catPhraseReference.anchors"
                          [isMissingInWorkingPhrase]="true"
                          [referenceIssue]="issue"
                          >

                          </copy-all-anchors>
                      </div>
                      <div class="ref-similarity-code">
                        <p class="missing">
                          {{ "translate.rev.refMissing" | translate }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </slide-in-out>
          </ng-container>
        </ng-container>

        <!-- Anchor context -->
        <ng-container *ngIf="!isFootnote">
          <ng-container *ngFor="let ref of anchorContext">

              @let anchorReferenceIssue = !(catMatches && catMatches.length > 0) ? null : getAnchorReferenceIssue(catMatches[currentIndex].catPhrase.phraseId, ref.refDocId);
              @let missingReferenceIssue = !(catMatches && catMatches.length > 0) ? null : getMissingAnchorReferenceIssue(catMatches[currentIndex].catPhrase.phraseId, ref.refDocId);

            <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility"
              [cssClass]="'accordionHeight'">
              <div class="cat-doc-phrase-ref-container" [ngClass]="getBorderClass(ref)">
                <phrase-ref class="ref" [ref]="ref" [mainPhraseWords]="phrase.phraseWords" [saveOriginalOnInit]="false" (onDeleteRef)="onDeleteRef(ref)"
                  [editable]="false" [allowEdit]="catModeSw" [mainPhrase]="phrase" [curCatDoc]="curCatDoc"
                  [showReferenceIssueType]="true"
                  [addedConsistencyGeneratedReference]="catMatches && catMatches.length > 0 && !anchorReferenceIssue && !missingReferenceIssue"
                  (viewPageAndRefEmitter)="viewPageAndRef($event)" [refDoc]="getRefDoc(ref)"
                  [disableConsistencyCheckResultsActions]="conditionForDisablingConsistencyCheckResultActions"
                >
                </phrase-ref>
              </div>
            </slide-in-out>
            <ng-container *ngIf="isExpanded">
              <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility"
                [cssClass]="'accordionHeight'">              
                  <div style="height: 100% !important" [ngClass]="anchorReferenceIssue.isConsistencyGenerated ? 'border-indicator-anchor' : 'border-indicator-reference'"
                  *ngIf="anchorReferenceIssue; else checkReferenceIssue">
                  <phrase-ref class="ref" [ref]="anchorReferenceIssue" [mainPhrase]="phrase" [mainPhraseWords]="phrase.phraseWords" [saveOriginalOnInit]="false"
                    [curCatDoc]="curCatDoc" (onDeleteRef)="onDeleteRef(anchorReferenceIssue)"
                    [editable]="false"
                    [showAddAnchors]="false"
                    [matchedRef]="ref"
                    [showMatchSimilarityCode]="false"
                    [disableConsistencyCheckResultsActions]="conditionForDisablingConsistencyCheckResultActions"
                    [displayActionsForUpdatingAnchors]="false"
                    (viewPageAndRefEmitter)="viewPageAndRef($event)" [refDoc]="getRefDoc(anchorReferenceIssue)">
                  </phrase-ref>
                </div>
                <ng-template #checkReferenceIssue>
                  <div style="height: 100% !important"
                    *ngIf="missingReferenceIssue; else missingAnchorInCat">
                    <cat-match-phrase-ref class="ref" [ref]="ref" [mainPhrase]="phrase"
                      [showBorderIndicator]="true"
                      [catPhrase]="catMatches[currentIndex].catPhrase" [referenceIssue]="missingReferenceIssue"
                      [refMatches]="catMatches[currentIndex].refMatch" [workingPhrase]="phrase">
                    </cat-match-phrase-ref>
                  </div>
          
                </ng-template>
                <ng-template #missingAnchorInCat>
                      <div class="missing-anchor-context">
                      </div>
                </ng-template>
              </slide-in-out>
            </ng-container>
            
          </ng-container>
          <ng-container *ngIf="isExpanded && catMatches.length > 0 && catMatchAnchorContext.length > 0">
              <ng-container *ngFor="let catMatchAnchorReference of catMatchAnchorContext">
                <ng-container *ngIf="getMissingCatMatchAnchorContext(catMatchAnchorReference)">
                  <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility" class="missing-anchor-context" [cssClass]="'accordionHeight'">
                  </slide-in-out>
                  <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility" [cssClass]="'accordionHeight'">
                    <div class="issues-column border-indicator-anchor" style="height: 100%">
                      <div class="cat-doc-phrase-details-ref-container">
                        <div class="ref-match-container" style="display: flex; flex-direction: column;">
                          <div style="display: flex; flex-direction: row;">
                            
                            <div>
                              <p class="text">
                              {{ catMatchAnchorReference?.refPhraseText }}
                              </p>
                            </div>
                            <div style="margin-left: auto; display: flex; align-items: center;">
                              <div style="margin-right: 5px;" *ngIf="catMatchAnchorReference.anchors != null && catMatchAnchorReference.anchors.length > 0">
                                <copy-all-anchors [isMissingInWorkingPhrase]="true" 
                                [phrase]="phrase"
                                [copyAnchors]="true"
                                [disableConsistencyCheckResultsActions]="conditionForDisablingConsistencyCheckResultActions"
                                [catMatchReference]="catMatchAnchorReference"
                                [catMatchRefAnchors]="catMatchAnchorReference.anchors"

                                >

                                </copy-all-anchors>
                              </div>
                              <i *ngIf="canViewRefDoc(catMatchAnchorReference)"
                                style="cursor: pointer; color: #0978a2; margin-left: auto;"
                                class="icon fa-solid fa-arrow-up-right-from-square"
                                [class.selected]="true"
                                [tooltip]="'translate.general.viewRefDoc' | translate"
                                (click)="viewRefDoc(catMatchAnchorReference)">
                              </i>
                            </div>
                          </div>
                        <mng-anchors *ngIf="phrase" style="margin-top: 10px"  [anchors]="catMatchAnchorReference.anchors"
                              (viewPageAndRef)="viewPageAndRef($event)"
                              [phrase]="phrase"
                              (anchorToRemove)="removeIssueEvent()"
                              (showRefDoc)="viewRefDoc(catPhraseReference)"
                              [displayActions]="false"
                              [copyAnchors]="true"
                              [isMissingInWorkingPhrase]="true"
                              [catMatchReference]="catMatchAnchorReference"
                              [moveCopyButton]="false"
                              [disableActions]="conditionForDisablingConsistencyCheckResultActions"
                              >
                        </mng-anchors>
                          <div class="anchor-context-issue-label">
                            <p class="missing">
                              {{ "translate.rev.refMissing" | translate }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </slide-in-out>
              </ng-container>
              </ng-container>
          </ng-container>
          
        </ng-container>
       <ng-container *ngIf="phrase && showAddContextDropdown.value && !hideReferences.toggleVisibility">
        <add-anchor [curDoc]="curCatDoc" [phrase]="phrase"
        [disabled]="conditionForDisablingConsistencyCheckResultActions"
        [showAddContextDropdown]="showAddContextDropdown">

        </add-anchor>
        <div></div>
      </ng-container>
      </ng-container>

  </ng-template>
  
  <ng-template #imagesTemplate let-isTables="isTables" let-images="images" let-label="label" let-labelRightHandSide="labelRightHandSide" let-hideAssociatedImages="hideAssociatedImages" let-hasAssociatedImageIssues="hasAssociatedImageIssues">
      <ng-container *ngIf="phrase && (images.length > 0 || (hasAssociatedImageIssues && getSimilarityEvent()))">
        <div style="display: flex; margin-top: 5px">
            <ng-container *ngIf="phrase.isFullyFetched else loadingSpinner">
              <span style="margin-right: 5px" class="circle-badge" [ngClass]="!hasAssociatedImageIssues ? 'success' : (isFullMatch ? 'warning-info' : 'error')">
                <i [ngClass]="!hasAssociatedImageIssues ? 'pi pi-check' : (isFullMatch ? 'pi pi-exclamation-triangle' : 'pi pi-times')"></i>
              </span>
            </ng-container>
            <a class="cat-doc-phrase-details-ref-title" (click)="toggleAssociatedImages(hideAssociatedImages)">
              {{ label | translate }}
              <span [ngClass]="(hideAssociatedImages | async) ? 'pi pi-angle-down' : 'pi pi-angle-up'" style="margin-left: 0.3em;"></span>
            </a>
        </div>
        <ng-container *ngIf="isExpanded && catMatches.length > 0  && getSimilarityEvent()">
            <p class="cat-doc-phrase-details-ref-title"><span *ngIf="!(hideAssociatedImages | async)">{{ labelRightHandSide | translate}}</span></p>
        </ng-container>

        <ng-container *ngFor="let assocImg of images">
          <slide-in-out *ngIf="!(hideAssociatedImages | async)" [isOpen]="!(hideAssociatedImages | async)" [cssClass]="'accordionHeight'">
            <div class="t-row--med" style="height: 100%" #assocImagesDivs [attr.data-id]="assocImg.assocImageId">
              <div class="cat-doc-phrase-details-ref-container">
                <div class="ref-match-container">
                  <div>
                    <async-img [className]="associatedImagesClassName" *ngIf="assocImg.imgS3Key"  [url]="assocImg.imgUrl"></async-img>
          <ng-container *ngIf="assocImg.consistencyIssues && assocImg.consistencyIssues.length > 0">
            <div>
              <div style="display:flex; margin-top: 10px">
                <span style="margin-right: 5px" class="circle-badge error">{{ assocImg.consistencyIssues.length }}</span>
                <a class="cat-doc-phrase-details-ref-title" (click)="assocImg.hideConsistencyIssuesTable = !assocImg.hideConsistencyIssuesTable">
                  {{ "translate.general.consistencyIssues" | translate }}
                  <span [ngClass]="assocImg.hideConsistencyIssuesTable ? 'pi pi-angle-down' : 'pi pi-angle-up'"></span>
                </a>
              </div>
              <slide-in-out [isOpen]="!assocImg.hideConsistencyIssuesTable">
                <div class="cat-phrase-ref-container"
                  style="margin-top: 0.3em; height: auto !important; background-color: #fce9e8 !important; padding: 0.1em !important">
                <consistency-issues
                  [consistencyIssues]="assocImg.consistencyIssues"
                  [element]="phrase"
                  (viewConsistencyIssueEmitter)="viewConsistencyIssue($event)"
                  [disableActions]="conditionForDisablingConsistencyCheckResultActions"
                  >
                </consistency-issues>
                  <p
                    style="font-style:  italic; text-align: right; margin-right: 0.4em; margin-top: 0.2em; margin-bottom: 0.2em; color: #9d9fa2">
                    <ai-icon name="info-circle"></ai-icon>
                  </p>
                </div>
              </slide-in-out>
          
            </div>
          </ng-container>
                    <p class="ref-id">
                      {{ "translate.general.id" | translate }}: {{ assocImg.assocImageId }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </slide-in-out>

          <ng-container *ngIf="isExpanded && catMatches.length > 0  && getSimilarityEvent()">
            <slide-in-out *ngIf="!(hideAssociatedImages | async)" [isOpen]="!(hideAssociatedImages | async)" [cssClass]="'accordionHeight'">
              <div class="issues-column" style="height: 100%;">
                <ng-container *ngIf="getAssociatedImageFinding(catMatches[currentIndex].catPhrase.phraseId, assocImg.assocImageId)?.assocImageFinding === 'ADDED_ASSOC_IMAGE'">
                  <div class="ref ref-match-container missing-reference" style="direction: rtl; padding-right: 0.5rem;">
                    <div class="ref-similarity-code">
                      <p class="extra">
                        {{ "translate.rev.refAdded" | translate }}
                      </p>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!(getAssociatedImageFinding(catMatches[currentIndex].catPhrase.phraseId, assocImg.assocImageId)?.assocImageFinding === 'ADDED_ASSOC_IMAGE')">
                  <cat-match-phrase-assoc-image class="ref" [associatedImage]="assocImg" [mainPhrase]="catMatches[currentIndex].catPhrase"
                    [associatedImageFinding]="getAssociatedImageFinding(catMatches[currentIndex].catPhrase.phraseId, assocImg.assocImageId)">
                  </cat-match-phrase-assoc-image>
                </ng-container>
              </div>
            </slide-in-out>
          </ng-container>

        </ng-container>

        <ng-container *ngIf="isExpanded && catMatches.length > 0 && getSimilarityEvent()">
          <ng-container *ngFor="let issue of getMissingAssocImageFinding(catMatches[currentIndex].catPhrase.phraseId, isTables)">
            <slide-in-out *ngIf="!(hideAssociatedImages | async)" [isOpen]="!(hideAssociatedImages | async)" [cssClass]="'accordionHeight missing-reference'">
            <div class="reference-column">
              <div class="ref missing-reference"></div>
            </div>
            </slide-in-out>
            <slide-in-out *ngIf="!(hideAssociatedImages | async)" [isOpen]="!(hideAssociatedImages | async)" [cssClass]="'accordionHeight'">
              <div class="issues-column" style="height: 100%">
                <div class="cat-doc-phrase-details-ref-container">
                  <div class="ref-match-container">
                    <div>
                      <async-img *ngIf="getCatPhraseAssocImage(issue.catAssocImageId).imgS3Key"  [url]="getCatPhraseAssocImage(issue.catAssocImageId).imgUrl"></async-img>
                      <p class="ref-id">
                        {{ "translate.general.id" | translate }}: {{ issue.catAssocImageId }}
                      </p>
                    </div>
                    <div class="ref-similarity-code">
                      <p class="missing">
                        {{ "translate.rev.refMissing" | translate }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </slide-in-out>
          </ng-container>
        </ng-container>

      </ng-container>
  </ng-template>
<ng-template #matchesTemplate>
  <ng-container *ngIf="notPotentialNew">
    <div class="template-container" *ngFor="let match of element.catMatches">
      <cat-match [match]="match" [referenceIssues]="phrase.referenceIssues"> </cat-match>
    </div>
  </ng-container>
</ng-template>
<ng-template #imageMatchesTemplate>
  <ng-container *ngIf="notPotentialNew">
    <div class="template-container" style="margin-top: 0px !important">
      <cat-match [match]="element.catMatches[currentIndex]"> </cat-match>
    </div>
  </ng-container>
</ng-template>
<p-popover #opTypes appendTo="body" baseZIndex="999999">
    <ng-container *ngTemplateOutlet="typesTree"></ng-container>
</p-popover>

<ng-template #typesTree>
  <p-tree class="fs-small" [value]="catPhraseTypesTree" [(selection)]="selectedPhraseType" scrollHeight="250px"
    selectionMode="single" filter="true" (onNodeSelect)="onTypeSelected($event)"></p-tree>
</ng-template>

<!-- edit phrase buttons -->
<ng-template #dirtyBtns>

    <div style="display: flex; align-items: end;" *ngIf="indModeSw">
            <span 
      [ngClass]="isExpanded ? 'pi pi-angle-double-left' : 'pi pi-angle-double-right'" 
      (click)="toggle()"
      [title]="(isExpanded ? 'translate.collapse.cat-matches': 'translate.expand.cat-matches') | translate"
      style="cursor: pointer; font-size: 1.2rem;"
    ></span>
      <reeval-status-icon [target]="reevalTarget" (refresh)="onReevalRefresh()"></reeval-status-icon>
      </div>
  <div *ngIf="element.hasId && (isDirty() || hasWhitelistedWords())" class="t-small">
    <button class="t-button t-button-warn" [disabled]="loading || !validateBeforeSave()" (click)="onSaveClickedPreProcessing()">
      {{ "translate.general.saveChanges" | translate }}
    </button>
    &nbsp;
    <button class="t-button-outline t-button-warn" [disabled]="loading" (click)="discardChanges()">
      {{ "translate.general.discardChanges" | translate }}
    </button>
  </div>
  <div class="l-align-center" *ngIf="hasPrev && indModeSw">
    <span [title]="('translate.prev.navigate-rules' | translate)" class="pi pi-chevron-up prev"(click)="showPrevIndElement()" style="position: absolute; 
    left: 50%; transform: translateX(-50%); color: black"></span>


  </div>
</ng-template>
<ng-template #consistencyIssues>

          <ng-container *ngIf="element.consistencyIssues && element.consistencyIssues.length > 0">
            <div>
              <div style="display:flex; margin-top: 10px">
                <span style="margin-right: 5px" class="circle-badge error">{{ element.consistencyIssues.length }}</span>
                <a class="cat-doc-phrase-details-ref-title" (click)="hideClaimConsistenciesTable = !hideClaimConsistenciesTable">
                  {{ "translate.general.consistencyIssues" | translate }}
                  <span [ngClass]="hideClaimConsistenciesTable ? 'pi pi-angle-down' : 'pi pi-angle-up'"></span>
                </a>
              </div>
              <slide-in-out [isOpen]="!hideClaimConsistenciesTable">
                <div class="cat-phrase-ref-container"
                  style="margin-top: 0.3em; height: auto !important; background-color: #fce9e8 !important; padding: 0.1em !important">
                  <consistency-issues [consistencyIssues]="element.consistencyIssues"
                  [element]="element"
                  [disableActions]="conditionForDisablingConsistencyCheckResultActions"
                    (viewConsistencyIssueEmitter)="viewConsistencyIssue($event)">
                  </consistency-issues>
                  <p
                    style="font-style:  italic; text-align: right; margin-right: 0.4em; margin-top: 0.2em; margin-bottom: 0.2em; color: #9d9fa2">
                    <ai-icon name="info-circle"></ai-icon>
                  </p>
                </div>
              </slide-in-out>
          
            </div>
          </ng-container>
          <view-page-and-annotate-element *ngIf="showConsistencyIssuePhrases"
            [embeddedObjectAnnotation]="currEmbeddedObjectAnnotation"
            (closePdfViewerEmitter)="showConsistencyIssuePhrases = false"></view-page-and-annotate-element>
</ng-template>
<p-popover #opCatEntryStatus appendTo="body" baseZIndex="100">
    <ng-container *ngTemplateOutlet="catEntryStatusTmp"></ng-container>
</p-popover>

<ng-template #catEntryStatusTmp>
  <p-select [options]="catEntryStatusList" optionLabel="label" [(ngModel)]="element.catEntryStatus"
    (onChange)="opCatEntryStatus.hide()">
  </p-select>
</ng-template>

<p-popover #opFigureSubTypes appendTo="body" baseZIndex="99999999999999999">
    <p-select [options]="figureSubTypeList" optionLabel="label" [(ngModel)]="element.figureSubType"
      class="l-cell-spread-x" [placeholder]="'translate.general.select' | translate" [autofocus]="true"
      (onChange)="opFigureSubTypes.hide()">
    </p-select>
</p-popover>
<ng-template #footer>
  <div class="l-align-spaceBetween" *ngIf="hasNext && indModeSw">
    <span [title]="('translate.next.navigate-rules' | translate)"  class="pi pi-chevron-down next" (click)="showNextIndElement()"></span>


  </div>
</ng-template>

<ng-template #noMatches>
  <div class="template-container">
    <h3>
      {{ "translate.rev.noMatchesFound" | translate }}
    </h3>
  </div>
</ng-template>

    <!--Temporary solution, probably we won't use custom endpoint for categories-->
      <p-popover #opImageCategories appendTo="body" baseZIndex="99999999999999999">
          <p-select *ngIf="image != null" [options]="imageCategoriesForDoc" [(ngModel)]="currentFigureCategory"
            class="l-cell-spread-x" [placeholder]="'translate.general.image-categories' | translate" [autofocus]="true"
            (onChange)="opImageCategories.hide()">
          </p-select>
      </p-popover>
    
    <ng-template #loadingSpinner>
      <spinner style="margin-right: 5px" class="cat-phrase-status-spinner"></spinner>
    </ng-template>
    
    <modal-popup
  *ngIf="refDocToView != null"
  [flexible]="false"
  [hideHeader]="false"
  [title]="refDocToView.docName"
  [isOpen]="refDocToView != null"
  (onClose)="refDocToView = null"
>
  <div class="pdf-container">
    <pdf-viewer
      #docViewer
      [doc]="refDocToView"
      [initialPage]="1"
      [displayDrawMode]="false"
      [displayToggleBoundingBoxes]="false"
      [singlePage]="false"
    ></pdf-viewer>
  </div>
</modal-popup>